import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NameDto } from 'api/Common/Types'
import { InterestRateEligibilityCriteriaTypeDto } from 'api/Interest-Rates/InterestRateDto'
import { PaymentMethodDto } from 'api/PaymentProvider/Types/PaymentMethodDto'
import { BonusType } from 'api/Transaction/Types/BonusType'
import { TransactionDirectionType } from 'api/Transaction/Types/TransactionDirectionType'
import { TransactionsState } from 'api/Transaction/Types/TransactionsState'
import { TransactionsStatusReason } from 'api/Transaction/Types/TransactionsStatusReason'
import { TransactionTypeDto } from 'api/Wallet/Types/TransactionTypeDto'

import { TransactionState } from './types'

const initialState: TransactionState = {
  types: [],
  status: [],
  bonusTypes: [],
  bonusStatuses: [],
  statusReasons: [],
  paymentProviders: [],
  directionType: [],
  interestRateEligibilityCriteriaType: [],
  paymentAgent: {
    paymentAgents: [],
    paymentAgentWallets: [],
    clientWallets: [],
  },
}

export const transactionSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    setTransactionTypeAction: (
      state: TransactionState,
      action: PayloadAction<TransactionTypeDto[]>
    ) => {
      state.types = action.payload
    },
    setTransactionBonusTypeAction: (
      state: TransactionState,
      action: PayloadAction<BonusType[]>
    ) => {
      state.bonusTypes = action.payload
    },
    setTransactionBonusStatusesAction: (
      state: TransactionState,
      action: PayloadAction<NameDto[]>
    ) => {
      state.bonusStatuses = action.payload
    },
    setTransactionDirectionTypeAction: (
      state: TransactionState,
      action: PayloadAction<TransactionDirectionType[]>
    ) => {
      state.directionType = action.payload
    },
    setInterestRatesEligibilityTypesAction: (
      state: TransactionState,
      action: PayloadAction<InterestRateEligibilityCriteriaTypeDto[]>
    ) => {
      state.interestRateEligibilityCriteriaType = action.payload
    },
    setTransactionStatusAction: (
      state: TransactionState,
      action: PayloadAction<TransactionsState[]>
    ) => {
      state.status = action.payload
    },
    setTransactionStatusReasonAction: (
      state: TransactionState,
      action: PayloadAction<TransactionsStatusReason[]>
    ) => {
      state.statusReasons = action.payload
    },
    setPaymentProviderAction: (
      state: TransactionState,
      action: PayloadAction<PaymentMethodDto[]>
    ) => {
      state.paymentProviders = action.payload
    },
  },
})
